<script setup>
import { useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

const router = useRouter();

const openProfileSettings = () => {
  return router.push({ name: 'profile_settings_index' });
};
</script>

<template>
  <div
    class="mx-auto mb-4 mt-[-0.75rem] flex max-w-[42rem] items-center justify-center gap-2 px-4 text-center text-xs leading-5 text-n-amber-11"
  >
    <span class="i-lucide-alert-circle size-4 shrink-0 text-n-amber-10" />
    <p class="min-w-0 truncate !m-0">
      {{ $t('CONVERSATION.FOOTER.MESSAGE_SIGNATURE_NOT_CONFIGURED') }}
    </p>
    <Button
      link
      xs
      class="shrink-0 !p-0 !text-n-amber-11 hover:!text-n-amber-12"
      :label="$t('CONVERSATION.FOOTER.CLICK_HERE')"
      @click="openProfileSettings"
    />
  </div>
</template>
